export const GOOGLE_PLACES_API_KEY = 'GOOGLE_PLACES_API_KEY';
export const MIXPANEL_INIT_KEY = 'MIXPANEL_INIT_KEY';
export const SEGMENT_WRITE_KEY = 'SEGMENT_WRITE_KEY'
